import styled from 'styled-components';
import { IoIosCash } from 'react-icons/io';
import { FaFileInvoiceDollar, FaMoneyBillWave } from 'react-icons/fa';

export const Container = styled.div``;

export const KpiGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 24px;
  padding: 20px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const KpiCard = styled.div`
  background: #fff;
  border-radius: 10px;
  box-shadow: 0px 3px 6px #00000014;
  padding: 16px;
  border-left: 4px solid ${(p) => p.accent || '#122d58'};
`;

export const KpiLabel = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #7b7b7b;
  
`;

export const KpiValue = styled.div`
  margin-top: 6px;
  font-size: 22px;
  font-weight: 800;
  color: ${(p) => p.color || '#122d58'};
`;

export const KpiHint = styled.div`
  margin-top: 6px;
  font-size: 11px;
  color: #9a9a9a;
`;

export const SplitGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
`;

export const SectionCard = styled.div`
  background: #fff;
  border-radius: 10px;
  box-shadow: 0px 3px 6px #00000014;
  padding: 16px;
`;

export const SectionTitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
`;

export const SectionTitle = styled.div`
  font-size: 14px;
  font-weight: 800;
  color: #122d58;
`;

export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
`;

export const StatusPill = styled.span`
  background-color: ${(p) => (p.color || '#122d58')}15;
  color: ${(p) => p.color || '#122d58'};
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
`;

export const LinkButton = styled.button`
  background: transparent;
  border: none;
  color: #122d58;
  font-weight: 700;
  font-size: 12px;
  cursor: pointer;
  padding: 6px 8px;

  &:hover {
    text-decoration: underline;
  }
`;

export const FilterBar = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
`;

export const FilterLabel = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: #122d58;
`;

export const FilterSelect = styled.select`
  height: 32px;
  border: 1px solid #ebebeb;
  border-radius: 6px;
  padding: 0 10px;
  font-size: 12px;
  color: #122d58;
  background: #fff;
`;

export const FilterDateInput = styled.input`
  height: 32px;
  border: 1px solid #ebebeb;
  border-radius: 6px;
  padding: 0 10px;
  font-size: 12px;
  color: #122d58;
  background: #fff;
`;

export const FilterHint = styled.div`
  font-size: 12px;
  color: #7b7b7b;
  font-weight: 600;
`;

export const IconMoney = styled(IoIosCash).attrs({ size: '30px' })`
  color: #fff;
`;

export const IconReceivable = styled(FaMoneyBillWave).attrs({ size: '30px' })`
  color: #fff;
`;

export const IconPayable = styled(FaFileInvoiceDollar).attrs({ size: '30px' })`
  color: #fff;
`;

